<template>
    <router-link v-if="link === ''" class="payment-method" tag="a" :to="to" target="_blank">
        <div class="payment-method__img" :style="{ 'border-color': color }">
            <img :src="'data:image/png;base64,' + this.img" alt="logo">
        </div>
        <div class="payment-method__title" v-html="title"></div>
    </router-link>
    <a v-else class="payment-method" :href="to" target="_blank">
      <div class="payment-method__img" :style="{ 'border-color': color }">
        <img :src="'data:image/png;base64,' + this.img" alt="logo">
      </div>
      <div class="payment-method__title" v-html="title"></div>
    </a>
</template>

<script>
  export default {
    name: 'PaymentMethod',
    props: {
      img: {
        type: String
      },
      title: {
        type: String
      },
      color: {
        type: String,
        default: '#ffffff'
      },
      link: {
        type: String,
        default: '/payments/current'
      }
    },
    computed: {
      to() {
        return this.link === '' ? '/payments/current' :  this.link
      }
    }
  }
</script>

<style lang="scss" scoped>
    .payment-method {
        display: flex;
        align-items: center;
        text-decoration: none;
        max-width: 400px;

        &__img {
            position: relative;
            overflow: hidden;
            border: 1px solid;
            border-radius: 50px;
            height: 100px;
            width: 100px;
            min-width: 100px;

            img {
                width: 100%;
                height: 100%
            }
        }

        &__title {
            @extend %important-text;
            font-size: 18px;
            margin-left: 20px;
            flex: 1 1 100%;
        }
    }
</style>
